import { generateResources } from 'utils/GenerateResouces';

const resource = {
  name: 'fiscal_templates',
  label: 'Templates Fiscais',
  actions: ['list', 'show'],
  onlyPermission: true,
  parentName: 'financial'
};

export default generateResources(resource);
